import PublicHttpClient from '../../services/public-http-client';
import { ISgeDashboardResponse } from '../../../model/sge/dashboard/dashboard-response';

const basePath = (clientId: number) => `Public/Client/${clientId}/Dashboard`;

const getOverview = async (clientId: number): Promise<ISgeDashboardResponse> => {
    return await PublicHttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(clientId)}/Overview`
    }).then((response) => response.data);
};

const PublicDashboardAppService = { getOverview };
export default PublicDashboardAppService;
